import { Params, Routes } from '@angular/router';

function isAuthRedirect(queryParams: Params, fragment: string | null): boolean {
  if (queryParams['code'] || queryParams['token_hash'] || queryParams['error']) {
    return true;
  }
  if (queryParams['type'] === 'recovery') {
    return true;
  }
  if (!fragment) {
    return false;
  }
  const hash = new URLSearchParams(fragment);
  return hash.get('type') === 'recovery' || hash.has('access_token');
}

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'wanderungen',
    loadComponent: () => import('./wanderungen/wanderungen.page').then((m) => m.WanderungenPage),
  },
  {
    path: 'hike/:slug',
    loadComponent: () => import('./hike-details/hike-details.page').then((m) => m.HikeDetailsPage),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'auth/callback/:platform',
    loadComponent: () => import('./auth-callback/auth-callback.page').then((m) => m.AuthCallbackPage),
  },
  {
    path: 'auth/callback',
    pathMatch: 'full',
    loadComponent: () => import('./auth-callback/auth-callback.page').then((m) => m.AuthCallbackPage),
  },
  {
    path: 'profil',
    loadComponent: () => import('./profil/profil.page').then((m) => m.ProfilPage),
  },
  {
    path: 'abo',
    loadComponent: () => import('./abo/abo.page').then((m) => m.AboPage),
  },
  {
    path: 'favoriten',
    loadComponent: () => import('./favoriten/favoriten.page').then((m) => m.FavoritenPage),
  },
  {
    path: 'ueber-uns',
    loadComponent: () => import('./ueber-uns/ueber-uns.page').then((m) => m.UeberUnsPage),
  },
  {
    path: 'kontakt',
    loadComponent: () => import('./kontakt/kontakt.page').then((m) => m.KontaktPage),
  },
  {
    path: 'datenschutz',
    loadComponent: () => import('./datenschutz/datenschutz.page').then((m) => m.DatenschutzPage),
  },
  {
    path: 'impressum',
    loadComponent: () => import('./impressum/impressum.page').then((m) => m.ImpressumPage),
  },
  {
    path: 'hilfe',
    loadComponent: () => import('./hilfe/hilfe.page').then((m) => m.HilfePage),
  },
  {
    path: 'contributor/:slug',
    loadComponent: () => import('./contributor/contributor.page').then((m) => m.ContributorPage),
  },
  {
    path: 'checkout/success',
    loadComponent: () =>
      import('./checkout/success/checkout-success.page').then((m) => m.CheckoutSuccessPage),
  },
  {
    // Emailed claim link (/checkout/konto?claim=…): account step of the buy-first flow.
    path: 'checkout/konto',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
    data: { mode: 'claim' },
  },
  {
    path: 'checkout/cancel',
    loadComponent: () =>
      import('./checkout/cancel/checkout-cancel.page').then((m) => m.CheckoutCancelPage),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ({ queryParams, fragment }) => {
      if (!isAuthRedirect(queryParams, fragment)) {
        return '/home';
      }
      const q = new URLSearchParams();
      for (const [key, value] of Object.entries(queryParams)) {
        if (value == null || value === '') continue;
        if (Array.isArray(value)) {
          for (const item of value) q.append(key, String(item));
        } else {
          q.set(key, String(value));
        }
      }
      const qs = q.toString();
      const hash = fragment ? `#${fragment}` : '';
      return `/auth/callback${qs ? `?${qs}` : ''}${hash}`;
    },
  },
];
